import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { withThemeAndSize } from "../../withThemeAndSize/index.js";
import { cn as clsx } from "../../../helpers/react.js";
import '../../../assets/index57.css';const sectionHeader = "_sectionHeader_1mjms_2";
const text = "_text_1mjms_11";
const s = {
  sectionHeader,
  text
};
const SectionHeader = withThemeAndSize(
  forwardRef(({ className, children, buttonNode, ...rest }, ref) => /* @__PURE__ */ jsxs("div", { ...rest, className: clsx(s.sectionHeader, className), ref, children: [
    /* @__PURE__ */ jsx("span", { className: s.text, children }),
    buttonNode
  ] }))
);
SectionHeader.displayName = "Modal.SectionHeader";
export {
  SectionHeader
};
